module.exports = __webpack_public_path__ + "img/1484379627.5893cf46.jpg";